import {
    initMain
} from './vue/controllers/main';

window.homeVue = initMain([], {
    CountdownTimer: () => import('./vue/components/countdown-timer/CountdownTimer.vue')
}, []);